export default [
  {
    path: '/plans/sweep/list',
    name: 'plans.sweep.list',
    component: () => import('@/views/modules/plans/sweep-plan/ListSweepPlans'),
    meta: {
      module: 'plans.sweep',
      pageTitle: 'List All sweep Plans',
      breadcrumb: [
        { text: 'List sweep Plans', active: true, },
        { text: 'Create Plan', to: {name: 'plans.sweep.create'} }
      ],
    }
  },


  {
    path: '/plans/sweep/create',
    name: 'plans.sweep.create',
    component: () => import('@/views/modules/plans/sweep-plan/CreateSweepPlan'),
    meta: {
      module: 'plans.sweep',
      pageTitle: 'Plan Create',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.sweep.list'} },
        { text: 'Create Plan' , active: true}
      ],
    }
  },


  {
    path: '/plans/sweep/:id/edit',
    name: 'plans.sweep.edit',
    component: () => import('@/views/modules/plans/sweep-plan/EditSweepPlan'),
    meta: {
      module: 'plans.sweep',
      pageTitle: 'sweep Suction Plan Edit',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.sweep.list'} },
        { text: 'Create Plan' , to: {name: 'plans.sweep.create'}},
        { text: 'Edit Plan' , active: true}
      ],
    }
  },
]
